import { GridColumn } from 'src/components/GridWrapper';
import InvoiceInfoCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/InvoiceInfoCell';
import InvoiceNumberCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/InvoiceNumberCell';
import StatusDateCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/StatusDateCell';

const matchDocumentColumns: GridColumn<any>[] = [
  {
    field: 'errors',
    title: '',
    width: 40,
    menu: false,
    component: InvoiceInfoCell,
  },
  {
    field: 'invoiceNumber',
    title: 'Document #',
    filter: 'text',
    dataType: 'string',
    component: InvoiceNumberCell,
  },
  {
    field: 'status',
    title: 'Status',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'companyName',
    title: 'Company',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'buyerName',
    title: 'Buyer Name',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    component: StatusDateCell,
    format: 'MM/dd/yyyy',
    filter: 'date',
    dataType: 'date',
  },
  {
    field: 'supplierName',
    title: 'Supplier Name',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'totalCostAmt',
    title: 'Doc Total',
    format: '{0:c2}',
    filter: 'numeric',
    dataType: 'dollar',
    filterFormat: 'c',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    filterFormat: 'c',
  },
];

export default matchDocumentColumns;
